import React from "react";
import { useTranslation } from "react-i18next";
import PageHeaderSolutions from "../components/PageHeaderSolutions";
import { CaretRightFilled } from "@ant-design/icons";
import HealthcareBanner from "../appareas/HealthcareBanner";
import DiagnosticsDataset from "./charts/DiagnosticsDataset"
import DiagnosticsModel from "./charts/DiagnosticsModel"

const Diagnostics = () => {
  const { t } = useTranslation();
  return (
    <>
      <PageHeaderSolutions></PageHeaderSolutions>
      <section className="mt-24 w-full h-full relative bg-center bg-cover p-5 border-2 border-blue-900 rounded-lg bg-white">
        <div> <HealthcareBanner></HealthcareBanner> </div>
        <div className="items-center text-center">
          <h3 className="mt-2 text-blue-900 text-4xl font-semibold mb-2">
            {t("diagnostics")}
          </h3>
        </div>

        <p className="text-2xl">
          <CaretRightFilled />
          {t("diagnostics_description1")}
        </p>


        <DiagnosticsDataset></DiagnosticsDataset>
        <DiagnosticsModel></DiagnosticsModel>


      </section>
    </>
  );
};

export default Diagnostics;
